import { getBackgroundTaskStateStorage } from '@juvare/contact-management/backend/features/background-task-state';
import { isProdEnvironment } from '@juvare/contact-management/backend/utils';
import { BackgroundTaskDef } from '@juvare/platform-app/App';
import { AppState } from '@juvare/platform-sdk-react/types';
import { minutesToMilliseconds } from 'date-fns';
import { millisecondsInDay } from 'date-fns/constants';
import { requestNeededBackgroundChecks } from '../utils/requestNeededBackgroundChecks';

const taskFrequencyProd = millisecondsInDay;
const taskFrequencyDev = minutesToMilliseconds(5);

const taskName = 'backgroundCheckRequestAvailable';

export const backgroundCheckRequestAvailableTask: BackgroundTaskDef<AppState> = {
    callback: (context) => {
        const backgroundTaskStateStorage = getBackgroundTaskStateStorage(context);
        const backgroundTaskStateResponse = backgroundTaskStateStorage.list({
            filter: [{ column: 'taskName', op: '=', value: taskName }],
            limit: 1,
        });
        const backgroundTaskState = backgroundTaskStateResponse.total > 0 ? backgroundTaskStateResponse.rows[0] : null;
        // default bounce timestamp - 1 day
        const lastRunTimestampInSeconds = backgroundTaskState?.columns.lastRunTimestamp ?? Date.now() - taskFrequencyProd;
        const runTimestampInSeconds = Date.now();

        if (isProdEnvironment(context.environment) && lastRunTimestampInSeconds > runTimestampInSeconds - taskFrequencyProd) {
            return;
        }

        requestNeededBackgroundChecks({ context, requestedBy: 'System' });

        backgroundTaskStateStorage.post({
            action: 'create-or-update',
            uniqueColumn: 'taskName',
            data: {
                taskName: taskName,
                lastRunTimestamp: runTimestampInSeconds,
            },
        });
    },
    delaySeconds: taskFrequencyDev,
};
